module.exports = __webpack_public_path__ + "img/c04_unitmountedarcher_Normal_ua.5c88fdb1.webp";